export default "__VITE_ASSET__CsuZQZtO__"